export default __webpack_public_path__ + "static/media/FFBL.8671261f.png";